export default "__VITE_ASSET__132e8685__"